var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable } from "mobx";
import { DEFAULT_PRODUCT_AND_STATE_DATA } from "./types";
export class ProductAndProjectStateManager {
    constructor() {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({}, Object.freeze(DEFAULT_PRODUCT_AND_STATE_DATA))
        });
        Object.defineProperty(this, "handleUpdateByKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, data) => {
                const result = data[key];
                // null is not actually a valid type but the initial state from the Product Loading Provider is really screwy atm
                if (result !== undefined && result !== null) {
                    if (key === "locale" && typeof result === "string") {
                        this._data[key] = result.toLowerCase();
                    }
                    else {
                        this._data[key] = result;
                    }
                }
            }
        });
        makeObservable(this);
    }
    get data() {
        return this._data;
    }
    initializeConfiguration(data) {
        const originalKeys = Object.keys(this._data);
        /**
         * @note: Instead of setting `this._data = data`, instead we iterate over each
         * key in the new data set and assign it to the corresponding value
         * of the base object. This results in more optimal updates for MobX
         * because it can observe changes to the individual properties of
         * `this._data`. If we replaced the entire reference of `this._data`,
         * by setting `this._data = data`, it results in rerendering every component
         * that observes any property of `this._data`.
         */
        for (const key of originalKeys) {
            this.handleUpdateByKey(key, data);
        }
    }
    updateConfiguration(data) {
        const newKeys = Object.keys(data);
        for (const key of newKeys) {
            this.handleUpdateByKey(key, data);
        }
    }
    /**
     * Unset, or delete, a key in the product/project configuration
     * @param key
     */
    unsetConfigurationKey(key) {
        delete this._data[key];
    }
}
__decorate([
    observable
], ProductAndProjectStateManager.prototype, "_data", void 0);
__decorate([
    computed
], ProductAndProjectStateManager.prototype, "data", null);
__decorate([
    action.bound
], ProductAndProjectStateManager.prototype, "initializeConfiguration", null);
__decorate([
    action.bound
], ProductAndProjectStateManager.prototype, "updateConfiguration", null);
__decorate([
    action.bound
], ProductAndProjectStateManager.prototype, "unsetConfigurationKey", null);
//# sourceMappingURL=ProductAndProjectStateManager.js.map